module.exports = __webpack_public_path__ + "icomoon.024466a6d3d4fbba24f5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/IcoMoon/icomoon.eot?87n1v6
// module id = 157
// module chunks = 5